import { jsx as e } from "react/jsx-runtime";
import r from "@mui/joy/Stack";
import { ChipItem as i } from "./ChipItem.js";
const o = ({ selected: o2, onChipDelete: t }) => e(r, { direction: "row", gap: 0.5, flexWrap: "wrap", children: o2 == null ? void 0 : o2.map((r2) => e(i, { id: r2 == null ? void 0 : r2.value, value: r2 == null ? void 0 : r2.label, disabled: r2 == null ? void 0 : r2.disabled, onDelete: t }, r2 == null ? void 0 : r2.value)) });
export {
  o as ChipsList
};
//# sourceMappingURL=ChipsList.js.map
